import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type PcConfirmDialogData = {
  text: string;
  confirmText: string;
  cancelText: string;
};

@Component({
  selector: 'pc-confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: PcConfirmDialogData) {}
}
